import { convertStringInDate, orderDate, sum } from "~services/GlobalServices";
import { applyRandomId, createDateInput, createVolumeInput, getFieldsByGroupType, getValueForGroupKey, groupByKey } from "../utils";

const useFunnelClientDashboard = ({ workFinished, orderFilter, verificaDataProximaNegociacao, lastStatusProdutos, handleVolumeUpdate, handleNegociacaoUpdate, handleUpdateAllData, handleUpdateAllEtapa }) => {
  const groupKey = orderFilter.value;

  const defaultWorkFinishedFunc = (func) => workFinished ? () => {} : func;
  const inputDisabled = () => ({
    disabled: workFinished
  });
  const actionButtonsAvailable = (actionButtons) => ({
    actionButtons: workFinished ? [] : actionButtons
  });

const convertProductFromClientToTable = (products_grouped) => {
  const keys = Object.keys(products_grouped);
  const values = Object.values(products_grouped);

  const content = values.map((value, index) => {
    const objHeader = {
      label: "Próxima Negociação:",
      value: keys[index],
      id: value[0].id,
      dataNegociacao: value[0].dataNegociacao,
      grupoProdutoId: value[0].funilObraGrupoProdutoId,
      etapa: value[0].etapa,
      etapaSlug: value[0].etapaSlug
    };

    const groupings = { skus: [], groups: [] };

    for (const e of value) {
      if (e.funilObraProdutoId) {
        groupings.skus.push(e);
      } else {
        groupings.groups.push(e);
      }
    }

    const deleteByMapd = {
      grupo_nome: ["grupo"],
      etapa: ["etapa"],
    };
  const deleteBy = deleteByMapd[groupKey] || [];
    const accordion_header = defineTableHeader({
      ...objHeader,
     deleteBy,
      layoutFields: getFieldsByGroupType({
        header: objHeader,
        groupKey,
        ...inputDisabled(),
        handleUpdateData: defaultWorkFinishedFunc(handleUpdateAllData),
        handleUpdateEtapa: defaultWorkFinishedFunc(handleUpdateAllEtapa)
      })
    });

    const accordion_body = defineTableBody(value);

    return {
      accordion_header,
      accordion_body,
      error: verificaDataProximaNegociacao(
        (groupings.skus.length ? groupings.skus : value) || []
      )
    };
  });

  return content;
};


  const defineTableHeader = ({label, value, grupoProdutoId, dataNegociacao, etapa, id, etapaSlug, deleteBy, layoutFields}) => {
    switch(groupKey){
      case "proxima_negociacao":
        return {
          label,
          table_layout: true,
          funilObraGrupoProdutoId: grupoProdutoId,
          id,
          etapa,
          etapaSlug,
          deleteBy,
          table_data: {
            showSelectAll: false,
            header: {
              data: applyRandomId([createDateInput({ header: {
                funilObraGrupoProdutoId: grupoProdutoId,
                id,
                etapa,
                etapaSlug,
                dataNegociacao,
                deleteBy,
              }, ...inputDisabled(), handleUpdate: defaultWorkFinishedFunc(handleUpdateAllData), value: dataNegociacao })]),
            },
          },
          layout_fields: layoutFields
        };
      case "etapa":
      case "grupo_nome":
        return { label: value, table_layout: false, funilObraGrupoProdutoId: grupoProdutoId, id, etapa, etapaSlug, deleteBy, layout_fields: layoutFields };
    }
  };

  const defineRowsTableBody = (item) => {
    let rows = [];

    (item || []).map((data) => {
      rows.push({
        columns: [],
        dados: data,
      });
    });
    return rows;
  };

  const defineSkuTable = ({data, hasSku}) => {
    let rows = [];

    (data || []).map((item) => {
      rows.push({
        columns: applyRandomId([
          ...(hasSku ? [{ value: item.produtoNome ?? "-" }] : []),
          createVolumeInput({ header: item, handleUpdate: defaultWorkFinishedFunc(handleVolumeUpdate), ...inputDisabled(), value: item.volumeEstimado, labelOn: false }),
          createDateInput({ header: item, handleUpdate: defaultWorkFinishedFunc(handleNegociacaoUpdate), ...inputDisabled(), value: item.dataNegociacao, labelOn: false }),
          { value: item.status, tooltip: "Tooltip de informação" },
        ]),
        dados: {
          id: item.id,
          grupoProdutoId: item.funilObraGrupoProdutoId,
          etapa: item.etapa,
          etapaSlug: item.etapaSlug,
          deleteBy: ['id']
        },
      });
    });
    return rows;
  };

  const defineTableBody = (value) => {
    let body = null;
    let rows = [];

    const values = value;

    rows = [...defineRowsTableBody(values)];

    if((values || []).length == 1 && groupKey != "proxima_negociacao") rows = [];

    let sub = {
      showSelectAll: false,
      header: {},
      body: {
        ...actionButtonsAvailable(["edit", "delete"]),
        rows,
      },
    };

    //HEADERS
    let actionButtons = ["edit", "delete"];

    // Remover botões de ação se as condições específicas forem atendidas
    if ((["grupo_nome", "etapa"].includes(groupKey) && (values || []).length > 1) || groupKey === "proxima_negociacao") {
      actionButtons = [];
    }

    //PRIMEIRA HIERARQUIA PÓS HEADERS
    let agrouped_values = [];

    switch(groupKey){
      case "grupo_nome":
        agrouped_values = groupByKey(values, "etapa");
        break;
      case "etapa":
        agrouped_values = groupByKey(values, "grupoNome");
        break;
      case "proxima_negociacao":
        agrouped_values = values.reduce((acc, cur) => {
          const key = `${cur.etapaSlug}-${cur.grupoNome}`;
          if(!acc[key]) acc[key] = [];

          acc[key].push(cur);
          return acc;
        }, {});
        break;
    }

    // const orderDateAsc = orderDate(values, "dataNegociacao");
    // const orderDateDesc = orderDate(values, "dataNegociacao", 'desc');

    let toControlValues = [...values];
    const agroupedHeaderValues = [];
    const skus = [];
    const group = [];

    Object.values(agrouped_values).forEach(e => {
      if(Array.isArray(e)){
        e.forEach(e => {
          if(e.funilObraProdutoId) skus.push(e);
          else group.push(e);
        })

        agroupedHeaderValues.push(...(skus.length > 0 ? skus : group));
      }
    })

    const firstHeader = toControlValues?.length == 1 ? values[0] : {
      volumeEstimado: sum(group, "volumeEstimado"),
      proximaNegociacao: orderDate(agroupedHeaderValues, "dataNegociacao")[0]?.dataNegociacao,
      status: lastStatusProdutos(agroupedHeaderValues)
    };

    const columns = applyRandomId([
        ((["etapa"].includes(groupKey)) && toControlValues?.length == 1 ? { value: firstHeader.grupoNome } : null ),
        ...( ["etapa", "grupo_nome"].includes(groupKey) && toControlValues?.length == 1 ?
            [
              createVolumeInput({ header: firstHeader, handleUpdate: defaultWorkFinishedFunc(handleVolumeUpdate), value: firstHeader.volumeEstimado, ...inputDisabled() }),
              createDateInput({ header: firstHeader, handleUpdate: defaultWorkFinishedFunc(handleNegociacaoUpdate), value: firstHeader.dataNegociacao, ...inputDisabled() })
            ] : [
              { label: "Volume Total:", value: firstHeader.volumeEstimado },
              { label: "Próxima Negociação:", value: convertStringInDate(firstHeader.proximaNegociacao || firstHeader.dataNegociacao, "pt-BR") },
            ]
          ),
        { label: "Último Status:", value: firstHeader.status, tooltip: "Tooltip de informação" },
    ]);

    body = {
      ...actionButtonsAvailable(actionButtons),
      rows: [
        {
          columns: ["etapa",'grupo_nome'].includes(groupKey) ? columns : []
        },
      ],
    };
    //FIM HEADERS

    agrouped_values = Object.values(agrouped_values);
    const actButtons = ["edit", "delete"];

    let accordion_headers = [];

    agrouped_values.map(av => {
    const isHeader = av?.length == 1;
    let headerLeader = null;
    const groupWithSKU = [];

    for (const e of av) {
      if (!e.funilObraProdutoId) {
        if (!headerLeader) headerLeader = e;
      } else groupWithSKU.push(e);
    }

    const secondHeader = isHeader
      ? headerLeader
      : {
          volumeEstimado: headerLeader.volumeEstimado,
          dataNegociacao: orderDate(groupWithSKU, "dataNegociacao")[0]?.dataNegociacao,
          status: lastStatusProdutos(groupWithSKU),
          etapa: av[0]?.etapa,
          funilObraGrupoProdutoId: av[0]?.funilObraGrupoProdutoId,
          id: av[0]?.id,
          funilObraProdutoId: av[0]?.funilObraProdutoId,
          etapaSlug: av[0]?.etapaSlug,
          clienteId: av[0]?.clienteId,
          grupoNome: av[0]?.grupoNome
        };

    const childrenHasSKU = av.some(e => e.funilObraProdutoId);

    const obj = {
      ...actionButtonsAvailable(
        actButtons.filter(e => {
          switch (groupKey) {
            case "grupo_nome":
              return isHeader ? ["edit", "delete"].includes(e) : false;
            case "etapa":
              return isHeader
                ? ["edit", "delete"].includes(e)
                : ["delete"].includes(e);
            case "proxima_negociacao":
              return isHeader ? ["edit", "delete"].includes(e) : false;
          }
        })
      ),
      data: applyRandomId([
        ...getValueForGroupKey({
          groupKey,
          isHeader,
          item: secondHeader,
          ...inputDisabled(),
          handleUpdateVolume: handleVolumeUpdate,
          handleUpdateData: handleNegociacaoUpdate
        }),
        { label: "Último Status:", value: secondHeader.status }
      ]),
      sub: {
        showSelectAll: false,
        header: {
          data: [
            ...(childrenHasSKU ? [{ value: "Produto/Sku", name: "sku" }] : []),
            { value: "Volume", name: "volumeEstimado" },
            { value: "Próxima Negociação", name: "dataNegociacao" },
            { value: "Status", name: "status" }
          ].filter(e => e)
        },
        body: {
          ...actionButtonsAvailable(["delete", "edit"]),
          rows: isHeader
            ? []
            : defineSkuTable({
                data: av.filter(e => e.funilObraProdutoId),
                hasSku: childrenHasSKU
              })
        }
      },
      id: secondHeader.id,
      funilObraGrupoProdutoId: secondHeader.funilObraGrupoProdutoId,
      funilObraProdutoId: secondHeader.funilObraProdutoId,
      etapa: secondHeader.etapa,
      etapaSlug: secondHeader.etapaSlug,
      clienteId: secondHeader.clienteId,
      deleteBy: ["grupo", "etapa"]
    };

    accordion_headers.push(obj);

    return obj;
  });

    sub = {
      ...sub,
      is_accordion: true,
      show_more_header: true,
      accordion_header: accordion_headers,
      showSelectAll: false,
    };
    //FIM PRIMEIRA HIERARQUIA PÓS HEADERS

    return {
      data: {
        body,
      },
      sub,
    };
  };

  return { convertProductFromClientToTable };
};

export default useFunnelClientDashboard;
